function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.074 7.847h6.2v1.712l4.59-2.86-4.59-2.829v1.712h-6.2v2.265zm10.79 3.434H8.652V9.56l-4.58 2.87 4.58 2.829v-1.723h6.21v-2.254z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.779 2.807A9.64 9.64 0 00.72 13.237c1.466 3.577 4.92 5.91 8.754 5.91 3.833 0 7.288-2.333 8.753-5.91a9.64 9.64 0 00-2.059-10.43 9.406 9.406 0 00-13.326 0H2.78zm12.505 12.632a8.14 8.14 0 01-8.94 1.806c-3.066-1.28-5.067-4.302-5.067-7.654 0-3.353 2-6.375 5.068-7.655a8.14 8.14 0 018.94 1.807c3.19 3.232 3.19 8.463 0 11.696z"
}));

function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCompare;